import SettingFrame from "../../../../components/@settings/SettingFrame";
import UpdateShippingRule from "../../../../components/@shipping/shipping_rules/UpdateShippingRule";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ShippingRuleUpdatePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateShippingRule
                routeType={routeType}
            />
        </SettingFrame>
    )
}       